var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _g3, _g4, _g5, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOinqKeep = function SvgOinqKeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Oinq_keep_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 174.23 127.03",
    style: {
      enableBackground: "new 0 0 174.23 127.03"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Oinq_keep_svg__st0{fill:#4db96e}.Oinq_keep_svg__st1{fill:#242929}.Oinq_keep_svg__st2{fill:#a6d7b7}.Oinq_keep_svg__st3{fill:#4b5a6b}.Oinq_keep_svg__st4{fill:#7e8390}.Oinq_keep_svg__st5{fill:#3b9f60}.Oinq_keep_svg__st6{fill:#6fc282}.Oinq_keep_svg__st8{fill:#fff}.Oinq_keep_svg__st9{fill:#191919}")), /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Oinq_keep",
    transform: "translate(-438.709 -858.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Oinq_share",
    transform: "translate(10716.762 4434.651)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Group_2552",
    transform: "rotate(-7 -33919.14 82170.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5032",
    className: "Oinq_keep_svg__st0",
    d: "M20.73 24.45s-12.49-8.81-19.04-10c0 0-4.49-3.07-.22-5.98C.21 3.29 5.5 2.6 10.72 3.13s31.93 9.67 34.93 16.06-8.14 14.47-8.14 14.47-2.98 1.77-16.78-9.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5033",
    className: "Oinq_keep_svg__st0",
    d: "M20.73 24.45s-12.49-8.81-19.04-10c0 0-4.49-3.07-.22-5.98C.21 3.29 5.5 2.6 10.72 3.13c1.31.19 2.61.47 3.88.85-2.6 4.35-3.56 8.86.6 11.65 4.98 3.4 12.7-.39 18.56-4.59 5.81 2.68 10.7 5.64 11.89 8.16 3 6.37-8.14 14.47-8.14 14.47s-2.98 1.76-16.78-9.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5034",
    className: "Oinq_keep_svg__st1",
    d: "M15.39 4.2c-1.53-.47-3.09-.83-4.67-1.07C5.5 2.6.21 3.29 1.48 8.47c-4.27 2.93.22 5.98.22 5.98 2.66.65 5.21 1.66 7.6 2.99.62-4.93 2.75-9.55 6.09-13.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5035",
    className: "Oinq_keep_svg__st2",
    d: "M14.84 8.33s.29-2.24 1.66-2.56 9.75 2.42 11.02 3.87-4.16 2.43-7.73 1.73-4.84-1.73-4.95-3.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5036",
    className: "Oinq_keep_svg__st3",
    d: "M2.43 13.82s-1.63-.67-2-1.89S1.44 9.66 3.38 9.6c-1.13-.95-.53-2.88 2.13-3.68s4.94 1.6 4.04 4.99-1.54 5.17-3.17 4.5c-1.62-.67-3.95-1.59-3.95-1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5037",
    className: "Oinq_keep_svg__st4",
    d: "M3.29 13.89s-1.82-.44-2.32-1.46.96-2.06 2.56-.9 1.25 2.77-.24 2.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Group_2554",
    transform: "translate(-10143.333 -3545.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Group_2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5038",
    className: "Oinq_keep_svg__st5",
    d: "M14.8 15.49S27.37 8.77 31.23 3.6c0 0 4.45-2.46 4.85 2.69 4.69 1.37 2.88 6.34.12 10.67S14.26 40.3 7.87 39.87 0 25.78 0 25.78s-.07-3.46 14.8-10.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5039",
    className: "Oinq_keep_svg__st5",
    d: "M14.8 15.49S27.37 8.77 31.23 3.6c0 0 4.45-2.46 4.85 2.69 4.69 1.37 2.88 6.34.12 10.67-.73 1.06-1.53 2.06-2.4 3-2.3-4.36-5.45-7.37-9.52-5.07-4.92 2.73-5.35 11.32-4.63 18.48-4.72 3.8-9.25 6.68-11.78 6.51C1.47 39.44 0 25.79 0 25.79s-.07-3.47 14.8-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5040",
    className: "Oinq_keep_svg__st1",
    d: "M33.27 20.54c1.06-1.12 2.04-2.32 2.93-3.59 2.75-4.32 4.56-9.29-.12-10.67-.4-5.15-4.85-2.69-4.85-2.69-1.67 2-3.62 3.76-5.77 5.23 3.72 3.03 6.44 7.12 7.81 11.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5041",
    className: "Oinq_keep_svg__st3",
    d: "M31.41 4.54c.65-.59 1.51-.89 2.39-.84 1.13.26 1.36 1.97.54 3.7 1.26-.53 2.53.93 1.98 3.64s-3.47 3.57-5.76 1.15-3.42-3.83-2.16-4.94 3.01-2.71 3.01-2.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5042",
    className: "Oinq_keep_svg__st4",
    d: "M30.97 5.27s1.17-1.39 2.2-1.34 1.21 1.85-.43 2.69-2.77-.24-1.77-1.35z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5043",
    className: "Oinq_keep_svg__st5",
    d: "M-10126.2-3473.54c-.42-.34-.8-.72-1.15-1.13-.45-.49-.79-.92-1.03-1.22 3.91-.91 6.49-6.67 3.88-9.65-1.2-1.38-1.55-1.53-3.34-1.56-1.81 0-3.38 1.26-3.78 3.02-.58 2-.46 4.13.35 6.05-2.99-.01-4.63-1.8-6.39-4.19a18.97 18.97 0 0 1-2.34-3.79l-.29.21c-.83.6-1.83.91-2.86.9 2.26 4.22 5.89 7.99 10.34 8.84.75.2 1.52.32 2.3.36.17.01.34.01.51 0a6.078 6.078 0 0 0 2.65 3.03c2.14 1.15 5.01.06 5.01.08-.39.11-.8.15-1.2.12-.98-.08-1.9-.46-2.66-1.07zm-2.32-4.86c-1.05-.28-1.53-1.92-1.07-3.65.46-1.74 1.69-2.92 2.74-2.65 1.05.28 1.53 1.92 1.07 3.65s-1.69 2.93-2.74 2.65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5044",
    className: "Oinq_keep_svg__st0",
    d: "M-10138.18-3543.78c4.73-6.42 11.37-23.82-.72-23.6-10.28.19-20.15 5.37-23.26 7.14-12.51-3.68-24.72-3.32-26.18-3.04-8.79-.62-17.62.52-25.97 3.33-2.4-1.43-12.85-7.23-23.76-7.43-12.4-.23-5.07 18.12-.34 24.09-1.38 1.76-2.65 3.6-3.8 5.52-17.47 29.15-4.96 72.12 30.79 83.59 14.21 4.55 59.7 8.6 75.2-19.58 11.97-21.8 7.17-54.88-1.96-70.02z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5045",
    className: "Oinq_keep_svg__st5",
    d: "M-10138.18-3543.78c4.3-5.85 10.2-20.78 2.1-23.26 6.14 4.68-1.05 18.27-5.3 16.51-3.6-1.26-11.92-7.09-18.67-10.85-.86.44-1.58.84-2.09 1.14h-.04c7.05 4.19 18.1 10.67 20.47 17.27 8.83 24.67 9.54 47.03-4.9 68.46-9.16 13.58-27.98 17.73-42.2 18.88a80.212 80.212 0 0 1-34.67-4.1c3.79 2.33 7.84 4.19 12.08 5.54 14.21 4.55 59.7 8.6 75.2-19.59 11.95-21.78 7.15-54.86-1.98-70z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5046",
    className: "Oinq_keep_svg__st6",
    d: "M-10208.18-3559.34s-31.08 10.07-36.97 32.22c-4.91 18.38 2.62 44.8 19.3 56.38 16.68 11.58 53.62 9.56 65.76-2.38 15.51-15.25 7.4-28.37-3.39-28.93 0 0-13.95-6.09-19.18-.04-2.62 3.78-14.2 22.39-15.18 16.35-18.66 11.43-32.42 1.19-20.2-16.53-5.26 1.62 5.07-17.41 17.25-27.09 15.15-12.03 39.12-3.54 48.46 13.65 7.06 12.98 10.47-28.13-5.23-36.18s-33.93-9.96-50.62-7.45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5047",
    className: "Oinq_keep_svg__st6",
    d: "M-10153.86-3554.5s10.07 6.81 11.55 9.47c2.36-.3 5.92-10.66 5.33-14.21-.59-3.55-10.65-2.65-16.88 4.74z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5048",
    className: "Oinq_keep_svg__st6",
    d: "M-10220.69-3551.88s-10.07 6.81-11.55 9.47c-2.37-.29-5.92-10.66-5.31-14.21.61-3.54 10.64-2.66 16.86 4.74z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5049",
    className: "Oinq_keep_svg__st5",
    d: "M-10136.98-3559.23c-.05-.27-.16-.53-.31-.76-.16-.23-.36-.42-.6-.56-.34 3.6-1.13 9.2-4.66 9.84-3.31.74-7.69-2.62-10.59-4.6-.25.26-.49.53-.72.82 0 0 10.07 6.81 11.55 9.47 2.37-.29 5.92-10.66 5.33-14.21z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5050",
    className: "Oinq_keep_svg__st2",
    d: "M-10233-3538.93s-10.14 11.11-12.11 24.54 4.25 7.85 8.83-6.22 10.14-21.27 11.78-24.54-4.58 1.64-8.5 6.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oinq_keep_svg__Path_5051_00000088132545428027588780000014080439777909175948_",
    gradientUnits: "userSpaceOnUse",
    x1: -10439.534,
    y1: -2850.927,
    x2: -10439.534,
    y2: -2851.927,
    gradientTransform: "matrix(4.3733 0 0 -8.0122 35466.297 -28473.701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#242929"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5051",
    style: {
      fill: "url(#Oinq_keep_svg__Path_5051_00000088132545428027588780000014080439777909175948_)"
    },
    d: "M-10186.65-3563.42c-.56.01-1.12.07-1.68.17 0 0-.97-.14-2.68-.2v6.33a1.307 1.307 0 0 0 .45.98c.49.45 1.13.7 1.8.69.67 0 1.3-.26 1.79-.72.11-.11.2-.25.25-.39.06-.15.08-.3.08-.46l-.01-6.4z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5052",
    className: "Oinq_keep_svg__st5",
    d: "M-10161.62-3565.35a.985.985 0 0 1-.53-.12c-.21-.11-.4-.25-.56-.41-7.79-7.89-11.48-3.5-11.63-3.32a.47.47 0 0 1-.27.16c-.12.02-.25.02-.38-.02-.32-.11-.61-.3-.83-.56a2.35 2.35 0 0 1-.54-.93.86.86 0 0 1 .07-.75c.05-.06 4.83-5.74 14.48 4.04.25.25.44.56.55.89.1.25.09.52-.02.76-.07.14-.2.23-.34.26z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5053",
    className: "Oinq_keep_svg__st5",
    d: "M-10215.94-3561.78a.479.479 0 0 1-.38-.11.558.558 0 0 1-.1-.58c.09-.29.25-.55.46-.76 8.73-8.81 14.11-5.16 14.16-5.12.08.06.13.14.16.23.03.11.03.22 0 .33-.03.14-.09.27-.16.39-.08.14-.18.27-.29.39-.11.12-.24.23-.38.33-.13.09-.26.16-.41.22-.12.05-.25.07-.38.07-.1 0-.2-.03-.29-.08-.18-.12-4.36-2.9-11.37 4.17-.15.15-.33.28-.52.38-.15.08-.33.13-.5.14z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_keep_svg__Ellipse_189",
    className: "Oinq_keep_svg__st8",
    cx: -10176.18,
    cy: -3545.7,
    rx: 10.35,
    ry: 12.92
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_keep_svg__Ellipse_190",
    className: "Oinq_keep_svg__st8",
    cx: -10201.31,
    cy: -3545.39,
    rx: 10.43,
    ry: 14.44
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Group_2555",
    transform: "translate(-10184.507 -3549.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5054",
    className: "Oinq_keep_svg__st9",
    d: "M4.31 11.63a4.31 4.31 0 0 0 0-8.62 4.31 4.31 0 0 0 0 8.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5055",
    className: "Oinq_keep_svg__st1",
    d: "M7.48 4.39c.42 1.74.5 4.99-3.52 7.22.87.07 1.73-.12 2.49-.55.75-.43 1.36-1.08 1.74-1.86.38-.78.51-1.66.39-2.51-.13-.86-.51-1.66-1.1-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5056",
    className: "Oinq_keep_svg__st8",
    d: "M3.77 6.49a.939.939 0 1 0 0-1.88c-.52 0-.94.42-.94.94.01.52.43.94.94.94z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Group_2556",
    transform: "translate(-10202.667 -3549.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5057",
    className: "Oinq_keep_svg__st9",
    d: "M4.52 12.06c2.5 0 4.52-2.02 4.52-4.52 0-2.5-2.03-4.52-4.52-4.52A4.5 4.5 0 0 0 0 7.53c0 2.5 2.02 4.53 4.52 4.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5058",
    className: "Oinq_keep_svg__st1",
    d: "M7.84 4.46c.44 1.83.53 5.23-3.69 7.57.91.08 1.82-.12 2.61-.57.79-.45 1.43-1.13 1.83-1.95a4.507 4.507 0 0 0-.75-5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5059",
    className: "Oinq_keep_svg__st8",
    d: "M3.96 6.67c.54 0 .98-.44.98-.98s-.44-.98-.98-.98-.98.44-.98.98.44.98.98.98z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_keep_svg__Group_2557",
    transform: "translate(-10216.349 -3538.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5060",
    className: "Oinq_keep_svg__st5",
    d: "M20.92 3.96S8.35 5.62 2.13 16.99c-4.41 7.93-2.48 20.38 10.51 19.95s20.22.49 27.17 3.1 17.5 2.06 20.03-3.87 3.23-15.64-4.17-22.94S36.52.79 20.92 3.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5061",
    className: "Oinq_keep_svg__st0",
    d: "M3.25 22.05S.97 32.36 10.82 34.01s15.93-1 31.76 3.62 17.9-6.02 15.94-14.51S45.84 6.36 33.11 5.08 7.18 8.63 3.25 22.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5062",
    className: "Oinq_keep_svg__st5",
    d: "M18.14 22.21a4.031 4.031 0 0 1-4.36 3.62 4.029 4.029 0 0 1-2.94-4.84c.39-2.34 2.34-3.96 4.36-3.62 2.13.53 3.45 2.69 2.94 4.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5063",
    className: "Oinq_keep_svg__st1",
    d: "M19.19 23.57a4.031 4.031 0 0 1-4.36 3.62c-2.01-.33-3.33-2.5-2.94-4.84.21-2.2 2.16-3.81 4.36-3.62 2.01.33 3.33 2.5 2.94 4.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5064",
    className: "Oinq_keep_svg__st5",
    d: "M50.42 26.14c-.39 2.34-2.36 3.96-4.36 3.62a4.042 4.042 0 0 1-2.94-4.84c.39-2.34 2.34-3.96 4.36-3.62 2.14.54 3.45 2.7 2.94 4.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5065",
    className: "Oinq_keep_svg__st1",
    d: "M51.48 27.52a4.031 4.031 0 0 1-4.36 3.62c-2.02-.34-3.33-2.5-2.94-4.84.21-2.2 2.16-3.81 4.36-3.62 2.14.52 3.45 2.69 2.94 4.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5066",
    className: "Oinq_keep_svg__st2",
    d: "M33.77 6.42s-9.38-1.57-12.41 1.66c-.57 1.46 3.98 4.09 9.44 3.12s6.7-4.78 2.97-4.78z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5067",
    d: "m-10216.46-3485.91 51.66-7.46s16.34 16.83-1.06 24.33c-17.39 7.51-45.75-6.45-50.6-16.87z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5068",
    className: "Oinq_keep_svg__st8",
    d: "M-10216.46-3485.91s32.16 4.56 46.34 1.94l.69-1.44.85 1.11c1.35-.28 2.64-.82 3.78-1.6v-7.46l-51.66 7.45z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5069",
    d: "M-10197.69-3471.64s15.37-10.11 35.99-.42c-.01.01-11.95 11.3-35.99.42z",
    style: {
      fill: "#e41f5c"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5070",
    className: "Oinq_keep_svg__st5",
    d: "M-10190.39-3564.01s-.66 7.42.31 8.37-2.44-.22-2.44-.22l-1.61-5.73.87-2.81 2.87.39z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_keep_svg__Path_5071",
    className: "Oinq_keep_svg__st5",
    d: "M-10185.8-3563.67s-.84 7.08-1.81 8.03 2.44-.22 2.44-.22l1.61-5.73-.87-2.81-1.37.73z"
  })))));
};
export default SvgOinqKeep;